<script lang="ts">import { cfgGoogleAnalytics, cfgGoogleClientId, cfgGoogleTagManager } from "@infinitro/config";
import { stage, Stage } from "@infinitro/global";
const GOOGLE_CLIENT_ID = cfgGoogleClientId();
const GOOGLE_TAG_MANAGER = cfgGoogleTagManager();
const GOOGLE_ANALYTICS = cfgGoogleAnalytics();
let _stage = stage;
if (typeof window !== "undefined") {
	window.GOOGLE_CLIENT_ID = GOOGLE_CLIENT_ID;
	window.GOOGLE_TAG_MANAGER = GOOGLE_TAG_MANAGER;
	window.GOOGLE_ANALYTICS = GOOGLE_ANALYTICS;
	if (["localhost", "127.0.0.1"].includes(window.document.location.hostname)) _stage = Stage.Local;
	if (![Stage.Local].includes(_stage)) console.log(`google analytics [${stage}] ${GOOGLE_ANALYTICS}`);
	else console.log(`google analytics disabled on ${stage} and localhost`);
}
</script>

<svelte:head>
	{#if ![Stage.Local].includes(_stage)}
		{#if GOOGLE_CLIENT_ID}
			<meta name="google-signin-client_id" content={GOOGLE_CLIENT_ID} />
		{/if}
		{#if GOOGLE_ANALYTICS}
			<script
				async
				src={`https://www.googletagmanager.com/gtag/js?id=${GOOGLE_ANALYTICS}`}
			></script>
		{/if}
		{#if GOOGLE_TAG_MANAGER}
			<script>
				window.dataLayer = window.dataLayer || [];
				function gtag() {
					dataLayer.push(arguments);
				}
				gtag('js', new Date());
				gtag('config', window.GOOGLE_TAG_MANAGER);
			</script>
			<script>
				(function (w, d, s, l, i) {
					w[l] = w[l] || [];
					w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
					var f = d.getElementsByTagName(s)[0],
						j = d.createElement(s),
						dl = l != 'dataLayer' ? '&l=' + l : '';
					j.async = true;
					j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
					f.parentNode.insertBefore(j, f);
				})(window, document, 'script', 'dataLayer', window.GOOGLE_TAG_MANAGER);
			</script>
		{/if}
	{/if}
</svelte:head>

{#if GOOGLE_TAG_MANAGER && ![Stage.Local].includes(_stage)}
	<noscript
		><iframe
			title="Google Tag Manager"
			src={`https://www.googletagmanager.com/ns.html?id=${GOOGLE_TAG_MANAGER}`}
			height="0"
			width="0"
			style="display:none;visibility:hidden"
		></iframe></noscript
	>
{/if}
